























































































































































































































































































































































import { Component, Watch } from "vue-property-decorator";
import { WorkerWizardModule } from "@/store/modules/workerWizard";
import GiganautVueForm from "@/components/Shared/GiganautVueForm";
import ListUtils from '@/lib/listUtils';
import KeyValueViewModel from "@/models/Shared/KeyValueViewModel";
import DateTimeUtils from "@/lib/dateTimeUtils";
import { AgencySettingsModule } from "@/store/modules/agencySettings";
import BranchDto from "@/models/Branches/BranchDto";
import WorkType from '@/models/Shared/WorkType';

@Component({
  name: "WorkerWizardDetails",
  components: { },
})
export default class WorkerWizardDetails extends GiganautVueForm {

 datePicker = false;
 //date: any = null;

  async validateForm() {
    // Work type is already selected and locked on step 1
    return !(this.$refs.form as any).validate();
  }

  get worker() {
    return WorkerWizardModule.newWorker.worker;
  }

  get workerVM() {
    return WorkerWizardModule.newWorker;
  }

  get isPermSelected() {
    return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Perm);
  }

  get isTempSelected() {
    return this.worker.workTypes && this.worker.workTypes.includes(WorkType.Temp);
  }

  get hasWorkTypeSelected() {
    return this.worker.workTypes && this.worker.workTypes.length > 0;
  }

  get desks() {
    if (this.workerVM.defaultBranch) {
      return this.workerVM.defaultBranch.desks;
    }
    return [];
  }

  get branches() {
      return AgencySettingsModule.branches;
  }

  get genders() {
    return ListUtils.genders();
  }

  get workTypes() {
    return ListUtils.workTypes();
  }

  get availabilityRestrictionTypes() {
    return ListUtils.availabilityRestrictions();
  }

  // get dateOfBirth() {
  //   if (this.worker.dateOfBirth != null) {
  //     return DateTimeUtils.toDDMMYY(this.worker.dateOfBirth)
  //   }
  //   return ''
  // }

  // set dateOfBirth(value) {
  //   WorkerWizardModule.newWorker.worker.dateOfBirth = new Date(`${value}T00:00Z`)
  // }

  @Watch("datePicker")
  datePickerChanged(val: boolean) {
        val && setTimeout(() => ((this.$refs.picker as any).activePicker = 'YEAR'))
    }

  get maritalStatuses() {
    return ListUtils.maritalStatuses();
  }

  get countries() {
    return ListUtils.countries();
  }

  get nationalities() {
    return ListUtils.nationalities();
  }

  get loading() {
    return WorkerWizardModule.loading;
  }

  async save(date: any) {
    (this.$refs.datePicker as any).save(date)
  }

}
